import React, { useState } from "react"; // Add useState
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

export default function Navbar() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false); // Add mobile menu state

  const handleSignOut = () => {
    navigate("/");
  };

  return (
    <>
      <div className="dashboard-navbar">
        <div className="dashboard-logo-container">
          <img
            src="/logo.png"
            alt="OffsetBridge logo"
            style={{ height: 32, filter: "brightness(1.2)" }}
          />
          <span
            className="dashboard-logo-text"
            onClick={() => (window.location.href = "/")}
          >
            OffsetBridge
          </span>
        </div>

        {/* Desktop Navigation */}
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <button
            className="howItWorks-btn desktop-nav-btn"
            onClick={() => navigate("/how-it-works")}
          >
            How It Works
          </button>
          <button
            className="login-btn desktop-nav-btn"
            onClick={handleSignOut}
          >
            Log Out
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <button
          className="mobile-menu-item"
          onClick={() => {
            navigate("/how-it-works");
            setMobileMenuOpen(false);
          }}
        >
          How It Works
        </button>
        <button
          className="mobile-menu-item"
          onClick={() => {
            handleSignOut();
            setMobileMenuOpen(false);
          }}
        >
          Log Out
        </button>
      </div>
    </>
  );
}